<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SYSTEM_SETTINGS' }
  ]"
></breadcrumbs>
<page-header title="SYSTEM_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="CURRENT_DATA_CYCLE">{{
        'CURRENT_DATA_CYCLE' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="dataCycles"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'SYSTEM_ACTIVE_DATA_CYCLE')"
          [ngClass]="{ 'is-danger': hasError('SYSTEM_ACTIVE_DATA_CYCLE') }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['SYSTEM_ACTIVE_DATA_CYCLE'])"
          class="is-small"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('SYSTEM_ACTIVE_DATA_CYCLE')">
        {{ getError('SYSTEM_ACTIVE_DATA_CYCLE') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="ROUNDING_FACTOR">{{
        'ROUNDING_FACTOR' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="roundFactors"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.value, 'SYSTEM_ROUND_FACTOR')"
          [ngClass]="{ 'is-danger': hasError('SYSTEM_ROUND_FACTOR') }"
          bindLabel="text"
          bindValue="value"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['SYSTEM_ROUND_FACTOR'])"
          class="is-small"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('SYSTEM_ROUND_FACTOR')">
        {{ getError('SYSTEM_ROUND_FACTOR') }}
      </p>
    </div>

    <div class="pb-4 pt-3">
      <h5 translationEditableDirective="OBJECT_CODES" class="mt-4 mb-4">
        {{ 'OBJECT_CODES' | translate }}
      </h5>
      <div class="rows">
        <div class="row">
          <div>
            <span translationEditableDirective="PROPERTY">{{
              'PROPERTY' | translate
            }}</span>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['PREFIX']"
            >
              <input
                [placeholder]="'PREFIX' | translate"
                class="input is-small"
                name="SYSTEM_PROPERTY_CODE_PREFIX"
                type="text"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_PROPERTY_CODE_PREFIX'])"
                [ngClass]="{
                  'is-danger': hasError('SYSTEM_PROPERTY_CODE_PREFIX')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_PROPERTY_CODE_PREFIX')"
            >
              {{ getError('SYSTEM_PROPERTY_CODE_PREFIX') }}
            </p>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['NUMBER_LENGTH']"
            >
              <number-input
                [placeholder]="'NUMBER_LENGTH' | translate"
                name="SYSTEM_PROPERTY_CODE_SERIAL_LENGTH"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_PROPERTY_CODE_SERIAL_LENGTH'])"
                [inputClass]="{
                  'input is-small': true,
                  'is-danger': hasError('SYSTEM_PROPERTY_CODE_SERIAL_LENGTH')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_PROPERTY_CODE_SERIAL_LENGTH')"
            >
              {{ getError('SYSTEM_PROPERTY_CODE_SERIAL_LENGTH') }}
            </p>
          </div>

          <div>
            <span
              *ngIf="
                getField(['SYSTEM_PROPERTY_CODE_PREFIX']) &&
                getField(['SYSTEM_PROPERTY_CODE_SERIAL_LENGTH'])
              "
              >{{ getField(['SYSTEM_PROPERTY_CODE_PREFIX'])
              }}{{
                getZeros(getField(['SYSTEM_PROPERTY_CODE_SERIAL_LENGTH']))
              }}</span
            >
          </div>
        </div>

        <div class="row">
          <div>
            <span translationEditableDirective="BUSINESS">{{
              'BUSINESS' | translate
            }}</span>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['PREFIX']"
            >
              <input
                [placeholder]="'PREFIX' | translate"
                class="input is-small"
                name="SYSTEM_BUSINESS_ID_PREFIX"
                type="text"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_BUSINESS_ID_PREFIX'])"
                [ngClass]="{
                  'is-danger': hasError('SYSTEM_BUSINESS_ID_PREFIX')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_BUSINESS_ID_PREFIX')"
            >
              {{ getError('SYSTEM_BUSINESS_ID_PREFIX') }}
            </p>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['NUMBER_LENGTH']"
            >
              <number-input
                [placeholder]="'NUMERIC_LENGTH' | translate"
                name="SYSTEM_BUSINESS_ID_NUMERIC_LENGTH"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_BUSINESS_ID_NUMERIC_LENGTH'])"
                [inputClass]="{
                  'input is-small': true,
                  'is-danger': hasError('SYSTEM_BUSINESS_ID_NUMERIC_LENGTH')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_BUSINESS_ID_NUMERIC_LENGTH')"
            >
              {{ getError('SYSTEM_BUSINESS_ID_NUMERIC_LENGTH') }}
            </p>
          </div>

          <div>
            <span
              *ngIf="
                getField(['SYSTEM_BUSINESS_ID_PREFIX']) &&
                getField(['SYSTEM_BUSINESS_ID_NUMERIC_LENGTH'])
              "
              >{{ getField(['SYSTEM_BUSINESS_ID_PREFIX'])
              }}{{
                getZeros(getField(['SYSTEM_BUSINESS_ID_NUMERIC_LENGTH']))
              }}</span
            >
          </div>
        </div>

        <div class="row">
          <div>
            <span translationEditableDirective="BUILDING">{{
              'BUILDING' | translate
            }}</span>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['PREFIX']"
            >
              <input
                [placeholder]="'PREFIX' | translate"
                class="input is-small"
                name="SYSTEM_BUILDING_ID_PREFIX"
                type="text"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_BUILDING_ID_PREFIX'])"
                [ngClass]="{
                  'is-danger': hasError('SYSTEM_BUILDING_ID_PREFIX')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_BUILDING_ID_PREFIX')"
            >
              {{ getError('SYSTEM_BUILDING_ID_PREFIX') }}
            </p>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['NUMBER_LENGTH']"
            >
              <number-input
                [placeholder]="'NUMERIC_LENGTH' | translate"
                name="SYSTEM_BUILDING_ID_NUMERIC_LENGTH"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_BUILDING_ID_NUMERIC_LENGTH'])"
                [inputClass]="{
                  'input is-small': true,
                  'is-danger': hasError('SYSTEM_BUILDING_ID_NUMERIC_LENGTH')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_BUILDING_ID_NUMERIC_LENGTH')"
            >
              {{ getError('SYSTEM_BUILDING_ID_NUMERIC_LENGTH') }}
            </p>
          </div>

          <div>
            <span
              *ngIf="
                getField(['SYSTEM_BUILDING_ID_PREFIX']) &&
                getField(['SYSTEM_BUILDING_ID_NUMERIC_LENGTH'])
              "
              >{{ getField(['SYSTEM_BUILDING_ID_PREFIX'])
              }}{{
                getZeros(getField(['SYSTEM_BUILDING_ID_NUMERIC_LENGTH']))
              }}</span
            >
          </div>
        </div>

        <div class="row">
          <div>
            <span translationEditableDirective="COMPOUND">{{
              'COMPOUND' | translate
            }}</span>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['PREFIX']"
            >
              <input
                [placeholder]="'PREFIX' | translate"
                class="input is-small"
                name="SYSTEM_COMPOUND_ID_PREFIX"
                type="text"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_COMPOUND_ID_PREFIX'])"
                [ngClass]="{
                  'is-danger': hasError('SYSTEM_COMPOUND_ID_PREFIX')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_COMPOUND_ID_PREFIX')"
            >
              {{ getError('SYSTEM_COMPOUND_ID_PREFIX') }}
            </p>
          </div>

          <div class="field is-narrow">
            <div
              class="control"
              [translationEditableModalDirective]="['NUMBER_LENGTH']"
            >
              <number-input
                [placeholder]="'NUMERIC_LENGTH' | translate"
                name="SYSTEM_COMPOUND_ID_NUMERIC_LENGTH"
                (input)="handleFieldChange($event)"
                [value]="getField(['SYSTEM_COMPOUND_ID_NUMERIC_LENGTH'])"
                [inputClass]="{
                  'input is-small': true,
                  'is-danger': hasError('SYSTEM_COMPOUND_ID_NUMERIC_LENGTH')
                }"
              />
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('SYSTEM_COMPOUND_ID_NUMERIC_LENGTH')"
            >
              {{ getError('SYSTEM_COMPOUND_ID_NUMERIC_LENGTH') }}
            </p>
          </div>

          <div>
            <span
              *ngIf="
                getField(['SYSTEM_COMPOUND_ID_PREFIX']) &&
                getField(['SYSTEM_COMPOUND_ID_NUMERIC_LENGTH'])
              "
              >{{ getField(['SYSTEM_COMPOUND_ID_PREFIX'])
              }}{{
                getZeros(getField(['SYSTEM_COMPOUND_ID_NUMERIC_LENGTH']))
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
